import { render, staticRenderFns } from "./ArcCanvas.vue?vue&type=template&id=d1630ff4"
import script from "./ArcCanvas.vue?vue&type=script&lang=js"
export * from "./ArcCanvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports